export default {
  addQuote(state, data) {
    const newQuoteIdx = state.preventivi.findIndex(
      (quote) => quote.id === data.id
    );
    if (newQuoteIdx === -1) {
      state.preventivi.push(data);
    } else {
      state.preventivi[newQuoteIdx] = data;
    }
  },
};
